import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams, useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "layout/header";
import Footer from "layout/footer";
import PageHeader from "component/PageHeader";
import imgTop01 from "../../assets/images/img_top01.png";
import imgCorp from "../../assets/images/img_corp.png";
import imgSign from "../../assets/images/img_sign.png";
import imgCert01 from "../../assets/images/img_certify01.png";
import imgCert02 from "../../assets/images/img_certify02.png";
import imgCert03 from "../../assets/images/img_certify03.png";

const Introduce = () => {
  const { section } = useParams(); // URL 파라미터로 섹션 정보 가져오기
  const navigate = useNavigate();
  const [activeContent, setActiveContent] = useState("ceo"); // 기본으로 CEO 인사말이 보여짐
  const [pageTitle, setPageTitle] = useState("CEO 인사말"); // 기본 타이틀

  // 섹션별 제목 매핑
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sectionTitles = {
    ceo: "CEO 인사말",
    history: "연혁",
    award: "수상 · 인증",
    business: "사업분야",
  };

  const sectionDescriptions = {
    ceo: "INISSOFT CEO 인사말 | 사람과 사람을 잇는 기술로 기업의 성장을 함께 이끌어갑니다. 시스템 간 연계와 통합을 통해 새로운 비즈니스 가치를 창출합니다.",
    history:
      "INISSOFT 연혁 | 2016년부터 지금까지 끊임없는 기술 혁신과 성장을 거듭하며 연계 시스템 분야의 전문 기업으로 자리매김해 온 과정입니다.",
    award:
      "INISSOFT 수상·인증 | 기술혁신형 중소기업(Inno-Biz), 강소기업 확인, GS 인증 등 기술력과 신뢰성을 인정받은 각종 수상 및 인증 현황입니다.",
    business:
      "INISSOFT 사업분야 | 통합 인터페이스 관리, 업무 연계 시스템, 오픈 API 플랫폼, 빅데이터 수집 적재 시스템 등 4대 핵심 사업을 소개합니다.",
  };

  useEffect(() => {
    if (!section || !sectionTitles[section]) {
      // 잘못된 URL로 접근 시 기본 섹션(ceo)으로 리다이렉트
      navigate("/introduce/ceo");
    } else {
      setPageTitle(sectionTitles[section]); // 섹션에 맞는 제목 설정
      setActiveContent(section); // 섹션에 맞게 콘텐츠도 업데이트
    }
  }, [section, navigate, sectionTitles]);

  const breadcrumb = [
    { label: "홈", path: "/main" },
    { label: "회사소개" },
    {
      label: sectionTitles[activeContent],
      dropdown: Object.entries(sectionTitles).map(([key, label]) => ({
        label,
        key,
        onClick: () => navigate(`/introduce/${key}`),
      })),
    },
  ];

  // 드롭다운 메뉴 선택 시 호출되는 함수
  const handleDropdownSelect = (key) => {
    navigate(`/introduce/${key}`); // URL만 업데이트
  };

  //수상인증 이미지
  const baseImagePath = "/assets/images/";
  const awards = [
    {
      imageName: "img_award01.png",
      name: "i-AWARD 생활편의분야 대상",
      date: "2016-12-08",
      text: "한국인터넷전문가협회",
    },
    {
      imageName: "img_award02.png",
      name: "연구개발전담부서 인정서",
      date: "2020-07-28",
      text: "한국산업기술진형협회",
    },
    {
      imageName: "img_award03.png",
      name: "벤처기업확인서",
      date: "2021-10-13",
      text: "벤처기업확인기관",
    },
    {
      imageName: "img_award04.png",
      name: "SCI 우수기술 기업 인증",
      date: "2022-04-27",
      text: "SCI평가정보",
    },
    {
      imageName: "img_award05.png",
      name: "한국소프트웨어산업협회 정회원 등록",
      date: "2022-05-02",
      text: "한국소프트웨어산업협회",
    },
    {
      imageName: "img_award06.png",
      name: "인재육성형 중소기업 지정",
      date: "2022-09-30",
      text: "중소벤처기업부",
    },
    {
      imageName: "img_award07.png",
      name: "사내근로복지기금법인 설립",
      date: "2023-01-31",
      text: "국세청",
    },
    {
      imageName: "img_award08.png",
      name: "성과공유기업 확인서",
      date: "2024-01-08",
      text: "중소벤처기업부",
    },
    {
      imageName: "img_award09.png",
      name: "기술혁신형 중소기업(Inno-Biz) 인증",
      date: "2024-03-11",
      text: "중소벤처기업부",
    },
    {
      imageName: "img_award10.png",
      name: "강소기업 확인",
      date: "2024-05-01",
      text: "고용노동부",
    },
    {
      imageName: "img_award11.png",
      name: "청년 내일채움공제 가입",
      date: "2024-11-08",
      text: "중소벤처기업진흥공단",
    },
    {
      imageName: "img_award12.png",
      name: "청년일자리 강소기업 선정서",
      date: "2025-01-01",
      text: "고용노동부 · 중소벤처기업진흥공단",
    },
  ];

  const awardData = awards.map((award, index) => ({
    id: index + 1,
    image: `${baseImagePath}${award.imageName}`,
    name: award.name,
    date: award.date,
    text: award.text,
  }));

  const products = [
    {
      imageName: "img_product01.png",
      name: "SW 저작권 등록증 APIGW",
      date: "2021-03-01",
      text: "한국저작권위원회",
    },
    {
      imageName: "img_product02.png",
      name: "SW 저작권 등록증 LinkIN",
      date: "2021-03-01",
      text: "한국저작권위원회",
    },
    {
      imageName: "img_product03.png",
      name: "SW 저작권 등록증 ModelIN",
      date: "2021-03-01",
      text: "한국저작권위원회",
    },
    {
      imageName: "img_product04.png",
      name: "LinkIN APIGW 2.0 GS 인증",
      date: "2024-02-05",
      text: "한국정보통신기술협회",
    },
    {
      imageName: "img_product05.png",
      name: "ModelIN APIGW 2.0 GS 인증",
      date: "2024-02-05",
      text: "한국정보통신기술협회",
    },
    {
      imageName: "img_product06.png",
      name: "통합 인터페이스 관련 특허 출원",
      date: "2023-12-05",
      text: "특허청",
    },
  ];

  const productData = products.map((product, index) => ({
    id: index + 1,
    image: `${baseImagePath}${product.imageName}`,
    name: product.name,
    date: product.date,
    text: product.text,
  }));

  // AOS 초기화 및 리프레시
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div id="wrap">
      <Helmet>
        <title>{pageTitle} | INISSOFT 회사소개</title>
        <meta name="description" content={sectionDescriptions[activeContent]} />
        <meta
          name="keywords"
          content={`INISSOFT, 아이엔아이소프트, 회사소개, ${pageTitle}`}
        />
        <meta
          property="og:title"
          content={`${pageTitle} | INISSOFT 회사소개`}
        />
        <meta
          property="og:description"
          content={sectionDescriptions[activeContent]}
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content="https://www.inissoft.com/Thumbnails.png"
        />
      </Helmet>
      <Header />
      <section className="section">
        <PageHeader
          title={pageTitle}
          backgroundImage={imgTop01}
          breadcrumb={breadcrumb.map((item) => {
            // 드롭다운 항목에 클릭 이벤트를 추가
            if (item.dropdown) {
              return {
                ...item,
                dropdown: item.dropdown.map((dropdownItem) => ({
                  ...dropdownItem,
                  onClick: () =>
                    handleDropdownSelect(dropdownItem.key, dropdownItem.label), // 클릭 시 선택된 키 변경
                })),
              };
            }
            return item;
          })}
        />

        {/* ceo 인사말 */}
        {activeContent === "ceo" && (
          <div
            className="content ceo"
            data-aos="fade-up"
            data-aos-easing="ease-in-out"
            data-aos-delay="500"
          >
            <div className="container">
              <div className="flex-box">
                <div className="img-box">
                  <img src={imgCorp} alt="INISSOFT" />
                </div>
                <div className="info">
                  <span className="sub-title">
                    사람과 사람이 모여 시스템과 시스템 간 연결을 만듭니다.
                  </span>
                  <p>
                    아이엔아이소프트는 이러한 연계를 통해 비즈니스의 가능성을
                    확장하고, 새로운 기회를 창출하고 있습니다. 우리에게 시스템
                    간 연계는 단순한 기술적 작업이 아닙니다. 그것은 비즈니스와
                    사람을 잇고, 더 나은 성과와 혁신을 이끌어내는 중요한
                    과정입니다.
                  </p>

                  <span className="sub-title">
                    당신의 핵심 비즈니스에 집중하세요.
                  </span>
                  <p>
                    시스템 간 연계와 통합의 복잡함은 저희 아이엔아이소프트가
                    책임지겠습니다. 우리는 고객의 요구에 맞춘 맞춤형 솔루션을
                    제공하며, 이를 통해 고객이 본연의 비즈니스 목표에 집중할 수
                    있도록 돕고 있습니다.
                  </p>
                  <p>
                    우리는 기술과 사람을 잇는 가교가 되어, 고객의 성공을 위해
                    최선을 다하고 있습니다. 끊임없는 혁신과 기술적 전문성으로
                    고객의 신뢰를 얻으며, 지속적인 파트너십을 구축해 나갑니다.
                    아이엔아이소프트와 함께 새로운 가능성을 열어가세요. 우리의
                    경험과 전문성을 바탕으로 귀사의 성장을 가속화하고, 지속
                    가능한 성공을 이끌어드리겠습니다.
                  </p>

                  <div className="sign">
                    <img src={imgSign} alt="대표이사 이경훈" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* 연혁 */}
        {activeContent === "history" && (
          <div
            className="content history"
            data-aos="fade-up"
            data-aos-easing="ease-in-out"
            data-aos-delay="500"
          >
            <div className="container">
              <div className="history-box">
                <div className="box">
                  <div className="img-box">
                    <img src={imgCert03} alt="청년일자리강소기업" />
                  </div>
                  <div className="info">
                    <span className="title">2025</span>
                    <ul>
                      <li className="badge">청년일자리 강소기업 선정</li>
                    </ul>
                  </div>
                </div>
                <div className="box">
                  <div className="img-box">
                    <img src={imgCert01} alt="기술혁신형중소기업" />
                  </div>
                  <div className="info">
                    <span className="title">2024 ~ 2023</span>
                    <span className="sub-title">2024</span>
                    <ul>
                      <li className="location">영등포 반도아이비밸리 이전</li>
                      <li className="certify">기술혁신형 중소기업 인증</li>
                      <li className="certify">고용노동부 강소기업인증</li>
                    </ul>
                    <span className="sub-title">2023</span>
                    <ul>
                      <li className="build">사내근로복지기금법인 설립</li>
                      <li className="certify">고용노동부 강소기업 인증</li>
                    </ul>
                  </div>
                </div>
                <div className="box">
                  <div className="img-box">
                    <img src={imgCert02} alt="우수기술 인증기업" />
                  </div>
                  <div className="info">
                    <span className="title">2022</span>
                    <ul>
                      <li className="location">영등포 리드원센터 이전</li>
                      <li className="badge">청년 내일채움공제 가입</li>
                      <li className="certify">SCI 우수기술 기업 인증</li>
                      <li className="badge">
                        한국소프트웨어산업협회 정회원 등록
                      </li>
                      <li className="badge">인재 육성형 중소기업 지정</li>
                    </ul>
                  </div>
                </div>
                <div className="box">
                  <div className="img-box"></div>
                  <div className="info">
                    <span className="title">2021 ~ 2015</span>
                    <span className="sub-title">2021</span>
                    <ul>
                      <li className="certify">벤처기업 인증</li>
                    </ul>
                    <span className="sub-title">2020</span>
                    <ul>
                      <li className="location">서울 서울숲 AK밸리 이전</li>
                      <li className="build">연구개발전담부서 설립</li>
                    </ul>
                    <span className="sub-title">2015-2016</span>
                    <ul>
                      <li className="location">아이엔아이소프트 설립</li>
                      <li className="certify">
                        SMART APP AWARD 생활편의분야 대상
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* 수상인증 */}
        {activeContent === "award" && (
          <div className="content award">
            <div className="container">
              <p
                className="content-title"
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-delay="500"
              >
                수상 · 인증
              </p>
              <div
                className="card-box"
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-delay="500"
              >
                {awardData.map((card) => (
                  <div className="card" key={card.id}>
                    <div className="img-box">
                      <img src={card.image} alt={card.name} />
                    </div>
                    <div className="info">
                      <span className="name">{card.name}</span>
                      <span className="date">{card.date}</span>
                      <span className="txt">{card.text}</span>
                    </div>
                  </div>
                ))}
              </div>

              <p
                className="content-title"
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-delay="650"
              >
                제품
              </p>
              <div
                className="card-box"
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                data-aos-delay="650"
              >
                {productData.map((product) => (
                  <div className="card" key={product.id}>
                    <div className="img-box">
                      <img src={product.image} alt={product.name} />
                    </div>
                    <div className="info">
                      <span className="name">{product.name}</span>
                      <span className="date">{product.date}</span>
                      <span className="txt">{product.text}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* 사업분야 */}
        {activeContent === "business" && (
          <div
            className="content business"
            data-aos="fade-up"
            data-aos-easing="ease-in-out"
            data-aos-delay="500"
          >
            <div className="container">
              <div className="business-box">
                <div className="box">
                  <h4 className="box-name">ESB 사업 수행</h4>
                  <div className="list-group">
                    <span className="title">2025</span>
                    <ul className="list-dot">
                      <li>제로페이 민생지원금 시스템 연계 개발</li>
                      <li>우리은행 채널 시스템 고도화 </li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2024</span>
                    <ul className="list-dot">
                      <li>KB증권 인터페이스 고도화 리뉴얼</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2023</span>
                    <ul className="list-dot">
                      <li>다날 차세대 시스템 구축</li>
                      <li>KB 손해보험 차세대 시스템 구축</li>
                      <li>
                        새마을금고 데이터
                        <br /> 활용 서비스 및 플랫폼 구축
                      </li>
                      <li>
                        서민금융진흥원 청년도약계좌시스템
                        <br /> 대외 연계
                      </li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2022</span>
                    <ul className="list-dot">
                      <li>마이데이터 서비스 및 시스템 구축</li>
                      <li>제로페이 정책자금 플랫폼 기능 개선</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2021</span>
                    <ul className="list-dot">
                      <li>마이데이터 제공자 시스템 구축</li>
                      <li>제로페이 국민 지원금 구축</li>
                    </ul>
                  </div>
                </div>

                <div className="box">
                  <h4 className="box-name">비즈니스 서비스 구축</h4>

                  <div className="list-group">
                    <span className="title">2026</span>
                    <ul className="list-dot">
                      <li>교육부 초등학교 바우처프로그램 시스템 구축</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2025</span>
                    <ul className="list-dot">
                      <li>BNK경남은행 모바일뱅킹 외국인모드 구축</li>
                      <li>우리카드 통합단말 시스템 재구축</li>
                      <li>
                        포항산업과학연구원 출장비 관리시스템 거래내역 중계
                      </li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2024</span>
                    <ul className="list-dot">
                      <li>기업은행 서류관리시스템재구축사업</li>
                      <li>TFM ESG 공급망 Data 관리 시스템 구축</li>
                      <li>현대자동차 SES 개발 구축</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2023</span>
                    <ul className="list-dot">
                      <li>에이피더핀 마이데이터 시스템 구축</li>
                      <li>제로페이 정책자금 플랫폼 구축</li>
                      <li>
                        새마을금고 데이터
                        <br /> 활용 서비스 및 플랫폼 고도화
                      </li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2022</span>
                    <ul className="list-dot">
                      <li>우리금융 통합결제 플랫폼</li>
                      <li>쿠콘 수협 마이데이터 시스템 구축</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2021</span>
                    <ul className="list-dot">
                      <li>우리카드 오픈뱅킹 시스템 구축</li>
                      <li>KB 저축은행 EIMS 시스템 구축</li>
                      <li>한국 투자 저축은행 EIMS 시스템 구축</li>
                      <li>신한카드 차세대 EIMS 시스템 구축</li>
                      <li>CJ대한통운 차세대 택배시스템 구축</li>
                      <li>서민금융진흥원 데이터 플랫폼</li>
                    </ul>
                  </div>
                </div>
                <div className="box">
                  <h4 className="box-name">연구 개발</h4>
                  <div className="list-group">
                    <span className="title">2025</span>
                    <ul className="list-dot">
                      <li>PostIN v1.0 개발</li>
                      <li>ModelIN v3.0 개발</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2024</span>
                    <ul className="list-dot">
                      <li>LinkIN APIGW 2.0 GS 인증</li>
                      <li>ModelIN APIGW 2.0 GS 인증</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2023</span>
                    <ul className="list-dot">
                      <li>CodeIN v1.0 개발</li>
                      <li>CollectIN v1.0 개발</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2022</span>
                    <ul className="list-dot">
                      <li>OpenIN v1.0 개발</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2021</span>
                    <ul className="list-dot">
                      <li>LinkIN@OpenBank v1.2.1 개발</li>
                      <li>ModelIN v1.2 개발</li>
                      <li>LinkIN v1.3.1 개발</li>
                      <li>ModelIN v1.2 개발</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2020</span>
                    <ul className="list-dot">
                      <li>LinkIN v1.0 개발</li>
                    </ul>
                  </div>

                  <div className="list-group">
                    <span className="title">2019</span>
                    <ul className="list-dot">
                      <li>iModel v1.0 개발</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default Introduce;
